export default __webpack_public_path__ + "static/media/nodejs.07407bae.png";